<template>
  <div class="recommend">
    <common-layout>
      <div slot="header">
        <h3>推荐资源</h3>
      </div>
      <div slot="container">
        <!-- <div class="recommend-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623AA2; border: none;"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteAll"
          >批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear='search'
            style="width:30%"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>技术领域:</label>
          <el-select v-model="fieldValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>-->
        <div class="recommend-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="所属模块" align="center" prop="module"></el-table-column>
            <el-table-column label="名称" align="center" prop="name"></el-table-column>
            <el-table-column label="日期" align="center" prop="dateTime">
              <template slot-scope="scope">
                <span>{{ scope.row.dateTime?scope.row.dateTime: scope.row.date_time }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain">是</el-tag>
                <el-tag v-else type="danger" effect="plain">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button>-->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        >
        </el-pagination>-->
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="ruleForm"  ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属模块" prop="module">
              <el-input v-model="ruleForm.module" placeholder="请输入模块名称" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入名称" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item style="text-align:left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推荐度" prop="hotOrder">
              <!-- <el-input
                v-model.number="ruleForm.hot_order"
                placeholder="请输入推荐度"
                :disabled="ruleForm.hot == 2"
              ></el-input>-->
              <el-slider v-model="ruleForm.hotOrder" show-input :disabled="ruleForm.hot == 2"></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import editor from "../../components/yhQuillEditor";
export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      Title: "",
      total: 10,
      is_submit: true,
      per_page: 10,
      current_page: 1,
      searchValue: "",
      dialogFormVisible: false,
      fileList: [],
      tableData: [],
      ruleForm: {
        name: "",
        logo: "",
        hot: 2,
        hot_order: 0,
      },
      urlList: [
        /*"Resource_Academy",
        "Resource_Base",
        "Resource_Center",
        "Resource_Employment",
        "Resource_Gain",
        "Resource_Hatch",
        "Resource_Institution",
        "Resource_Instrument",
        "Resource_Laboratory",
        "Resource_Mechanism",
        "Resource_Need",
        "Resource_Result",
        "Resource_Small",
        "Resource_Space",
        "Resource_Transfer",*/
          "trade/resource-academy",
          "trade/resource-base",
          "trade/resource-center",
          "trade/resource-employment",
          "trade/resource-gain",
          "trade/resource-hatch",
          "trade/resource-institution",
          "trade/resource-instrument",
          "trade/resource-laboratory",
          "trade/resource-mechanism",
          "trade/resource-need",
          "trade/resource-result",
          "trade/resource-small",
          "trade/resource-space",
          "trade/resource-transfer"
      ],
      moduleList: [
        "产业研究院",
        "国际科技与合作基地",
        "研究中心",
        "创业就业孵化基地",
        "科技成果",
        "科技企业孵化器",
        "新型研发机构",
        "科研仪器",
        "重点实验室",
        "平台入驻机构",
        "技术需求",
        "科技成果转化基地",
        "中小企业公共服务示范平台",
        "众创空间",
        "技术转移示范机构",
      ],
      rules: {
        hot_order: [
          { required: true, validator: validateHoto, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/resource-recommand/list`);
  },
  methods: {
    getData(url) {
      this.http.get(url).then((res) => {
        if (res.code == 0) {
          this.tableData = JSON.parse(JSON.stringify(res.data));
          this.tableData.forEach((item) => {
            item.url = `${urlConfig.devUrl}apij2/admin-api/`+ this.urlList[item.recommend];
            item.module = this.moduleList[item.recommend];
          });
          //   this.total = res.data.total;
          //   this.per_page = res.data.per_page;
          //   this.current_page = res.data.current_page * 1;
        }
      });
    },
    //搜索
    // search() {
    //   this.getData(
    //     "Resource_Result?all=1&name=" +
    //       this.searchValue +
    //       "&page=" +
    //       this.current_page +
    //       (this.fieldValue ? "&field=" + this.fieldValue : "")
    //   );
    // },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.hotOrder = this.ruleForm.hotOrder|this.ruleForm.hot_order|0;
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let obj = {};
          obj.hot = 2;
          obj.hot_order = 0;
          obj.hotOrder = 0;
          obj.id = row.id;
          this.http.post(row.url + "/update", obj).then((res) => {
            if (res.code == 0) {
              this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/resource-recommand/list`);
              this.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              this.$message({
                message: "失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    // handleCurrentChange(e) {
    //   this.getData("Resource_Result?all=1&name=" + this.searchValue + '&page=' + e+(this.fieldValue?"&field="+this.fieldValue:''));
    // },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },

    //提交
    submitForm(name) {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          let obj = {};
          obj.hot = this.ruleForm.hot;
          obj.hot_order = this.ruleForm.hotOrder;
          obj.hotOrder = this.ruleForm.hotOrder;
          obj.id = this.ruleForm.id;
          this.http
            .post(this.ruleForm.url + "/update", obj)
            .then((res) => {
              if (res.code == 0) {
                this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/resource-recommand/list`);
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              } else {
                this.is_submit = true;
              }
            }).catch(err => {
              this.is_submit = true;
            });
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scope>
.recommend {
  height: 100%;
  width: 100%;
  //   .recommend-search {
  //     width: 100%;
  //     text-align: left;
  //     display: flex;
  //     justify-content: flex-start;
  //     align-items: center;
  //     /deep/.el-input--suffix{
  //       width: 100%;
  //       margin: 0 15px;
  //     }
  //     .el-input {
  //       // width: 400px;
  //       margin: 0 15px;
  //     }
  //     .date-picker {
  //       margin: 0 15px;
  //       .el-range-separator {
  //         width: auto;
  //       }
  //     }
  //   }
  .recommend-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
</style>
